import { render, staticRenderFns } from "./BaseReadView.vue?vue&type=template&id=5ffc0c5a&"
import script from "./BaseReadView.vue?vue&type=script&lang=js&"
export * from "./BaseReadView.vue?vue&type=script&lang=js&"
import style0 from "./BaseReadView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports